import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'

const baseStyles = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gap: 2,
  py: 2,
  px: 2,
  borderRadius: 4,
  backgroundColor: 'grey.900',
  textAlign: 'left',
  textDecoration: 'none',
  '&:hover': {
    backgroundColor: 'grey.800',
    textDecoration: 'none',
  },
}

const linkStyles = {
  ...baseStyles,
  '& a, & a:hover': {
    textDecoration: 'none !important',
  },
  '&:has(.MuiChip-clickable:hover)': {
    backgroundColor: 'grey.900',
  },
}

function ResourceListRow({ children, to, onClick }) {
  if (to) {
    return (
      <ButtonBase
        component={RouterLink}
        to={to}
        sx={linkStyles}
      >
        {children}
      </ButtonBase>
    )
  }

  if (onClick) {
    return (
      <ButtonBase
        onClick={onClick}
        sx={baseStyles}
      >
        {children}
      </ButtonBase>
    )
  }

  return (
    <Box sx={baseStyles}>
      {children}
    </Box>
  )
}

export default ResourceListRow
